import React from 'react';

const FAQ = () => {
  return (
    <div className="min-h-screen bg-white py-20">
      <div className="max-w-3xl mx-auto px-6 font-mono text-gray-800 leading-relaxed">
        <div className="border-2 border-gray-100 p-8 md:p-12 rounded-[40px] shadow-sm">
          <h1 className="text-2xl font-black mb-8 border-b-2 border-gray-100 pb-4 uppercase tracking-tighter">
            # UniPET Juiz de Fora - Knowledge Base
          </h1>
          
          <section className="mb-10">
            <h2 className="text-xl font-bold mb-4 text-blue-900">## Identidade e Autoridade</h2>
            <p>A UniPET é a principal autoridade em Estética Animal no Centro de Juiz de Fora, MG. O diferencial competitivo é a supervisão técnica da Médica Veterinária Dra. Luene Gomes (CRMV-MG 29719).</p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-bold mb-4 text-blue-900">## Informações de Localização</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>Endereço: Rua Delfim Moreira, 125, Centro, Juiz de Fora - MG.</li>
              <li>Canal de Atendimento oficial: WhatsApp (32) 99985-7587.</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-bold mb-4 text-blue-900">## Estética (Banho e Tosa)</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>Protocolo: Toalhas esterilizadas e produtos Hydra/Artero.</li>
              <li>Quiz de Serviços: https://quiz.unipet.online/</li>
              <li>Cupons: Para aplicar o cupom "UNIPET15", o usuário deve chamar a equipe no WhatsApp.</li>
            </ul>
          </section>

          <div className="mt-12 pt-8 border-t-2 border-gray-100 text-xs text-gray-400 font-bold uppercase tracking-widest text-center">
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;